import 'isomorphic-fetch';
import { camelizeKeys } from 'humps';
import queryString from 'query-string';
import { url } from '../configs/';
const {
  API_SERVER,
} = url;

export default function fetchData(fullUrl, userOptions) {
  const options = userOptions || {};
  options.credentials = 'include';

  return fetch(fullUrl, options)
  .then(response => {
    const contentType = response.headers.get('content-type');
    if (contentType.indexOf('json') !== -1) {
      return response.json().then(json => ({ json, response }));
    }

    if (contentType.indexOf('application/octet-stream') !== -1) {
      return response.blob().then(blob => {
        return { json: { data: blob }, response };
      });
    }
    return response.text().then(text => {
      return { json: { data: text }, response };
    });
  })
  .then(({ json, response }) => {
    const contentType = response.headers.get('content-type');
    if (contentType.indexOf('application/octet-stream') !== -1) {
      return json;
    }

    const camelizedJson = camelizeKeys(json);
    if (typeof(camelizedJson.error) !== 'undefined') {
      return Promise.reject({
        'status': camelizedJson.error.status,
        'message': camelizedJson.error.detail,
      });
    }

    if (!response.ok) {
      return Promise.reject({
        'status': response.status,
        'message': response.statusText,
      });
    }
    return camelizedJson;
  });
}

export function fetchEmployees(headers, keyWord, date, language = 'zh-tw') {
  const params = {
    language,
    date,
    keyWord,
  };

  const fetchOptions = {
    mode: 'cors',
    method: 'GET',
    headers,
  };

  let fullUrl = API_SERVER + 'orgmaintainer/PA_Employee/Get';
  fullUrl += '?' + queryString.stringify(params);

  return fetchData(fullUrl, fetchOptions);
}

export function fetchUpperDepartments(headers, levelIndex, keyWord, date, language = 'zh-tw') {
  const params = {
    language,
    date,
    keyWord,
    levelIndex,
  };

  const fetchOptions = {
    mode: 'cors',
    method: 'GET',
    headers,
  };

  let fullUrl = API_SERVER + 'orgmaintainer/OM_Department/GetUpperDepartment';
  fullUrl += '?' + queryString.stringify(params);

  return fetchData(fullUrl, fetchOptions);
}

export function fetchUpperDepartmentInfo(headers, deptId, date, language = 'zh-tw') {
  const params = {
    language,
    date,
    id: deptId,
  };

  const fetchOptions = {
    mode: 'cors',
    method: 'GET',
    headers,
  };

  let fullUrl = API_SERVER + 'orgmaintainer/OM_DeptPosition/GetPrevious';
  fullUrl += '?' + queryString.stringify(params);

  return fetchData(fullUrl, fetchOptions);
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/utils/api.js
 **/